import { Chip } from '@/components/kit';
import { useNarrowViewport } from '@/components/kit/useNarrow';
import { periodLabel, recentPeriods } from '../lib/useAccounts';
import { MonthPick } from './MonthPick';

/**
 * THE MONTH, AND WHOSE MONEY IT IS — the strip every board in this lane
 * carries, because every figure below it is meaningless without both.
 *
 * The branch line is not a filter. The accountant's scope is the clinic, so
 * it states what is being counted rather than offering to narrow it: an
 * invoice raised anywhere is money the clinic is owed, and a per-branch
 * ledger would be a fraction of the books presented as the whole.
 */
export function PeriodRow({
  period,
  onChange,
  branches,
  trailing,
}: {
  period: string;
  onChange: (next: string) => void;
  branches?: string[];
  /** Anything the board puts after the branch line. */
  trailing?: React.ReactNode;
}) {
  /* A phone's strip is one scrolling line of months — the branch sentence
     is the desk's, and squeezed beside the chips it stood one word wide. */
  const narrow = useNarrowViewport();
  if (narrow) {
    return (
      <div className="filterrow">
        <MonthPick period={period} onChange={onChange} />
        {trailing}
      </div>
    );
  }
  return (
    <div className="filterrow">
      {/* A month reached by a link (a claim's bill from July) is not in the recent
          strip — it still shows, selected, so the page never has no month on it. */}
      {(recentPeriods().includes(period) ? recentPeriods() : [period, ...recentPeriods()]).map((p) => (
        <Chip
          key={p}
          kind={p === period ? 'brand' : 'outline'}
          small
          onClick={() => onChange(p)}
        >
          {periodLabel(p)}
        </Chip>
      ))}
      {narrow ? null : <span className="t-cap mut" style={{ padding: '0 4px' }}>·</span>}
      {narrow ? null : <span className="t-sec mut">
        {branches?.length
          ? branches.length === 1
            ? `${branches[0]} — the clinic's only site`
            : `All branches — ${branches.slice(0, -1).join(', ')} and ${branches[branches.length - 1]}`
          : 'All branches'}
      </span>}
      {trailing}
    </div>
  );
}
